module.exports = __webpack_public_path__ + "img/12000.5deb0cb8.jpg";